import { Component, Input } from '@angular/core';
import Utils from '@util/util';

@Component({
  selector: 'app-investment-movement',
  templateUrl: './investment-movement.component.html',
  styleUrls: ['./investment-movement.component.scss'],
})
export class InvestmentMovementComponent {

  @Input()
  set date(contributionDate: Date) {
    const date = new Date(contributionDate['seconds'] * 1000);
    const month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
    const day = ('0' + date.getUTCDate()).slice(-2);
    const year = (date.getUTCFullYear());
    this.dateFormatted = `${day}/${month}`;
    this.dateFormattedFull = `${day}/${month}/${year}`;
  }
  @Input() selected: boolean;
  @Input() totalAmount: number;
  @Input() portfolioName: string;
  @Input() type: string;
  @Input() typeClass: string;
  @Input() referral: boolean;
  @Input() referred: boolean;
  @Input() fullDate: boolean;
  @Input() isUSD: boolean;
  @Input() purpleGift: boolean;
  @Input() fromRecurring?: boolean;
  @Input() isStockTransfer?: boolean;
  @Input() isRebateInterest?: boolean;
  dateFormatted: string;
  dateFormattedFull: string;
  math = Math;

  constructor() { }

}
